import Muncher, { AxisNames } from '.'

export default abstract class DimensionMuncher extends Muncher {
  /**
   * call - This method is an overrideable method, in order to use an specific implementation
   * in a bar muncher, lines muncher and area muncher due to the fact that these ones use axis
   * in order to calculate dimensions and group the data.
   *
   * @method
   */
  abstract call(): any

  /**
   * axisNames - This method returns an object with three properties xAxis, yAxis and groupBy,
   * if the Quert object does not have a tertiaryField the groupBy property will be null,
   * on the other hand it will return the groupBy property.
   *
   * @method
   */
  axisNames(): AxisNames {
    const { primaryField, secondaryField, tertiaryField } = this.query.fields

    return {
      yAxis: primaryField,
      xAxis: secondaryField,
      groupBy: tertiaryField,
    }
  }
}
